import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import * as moment from 'moment-timezone';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventNameComponent } from '../edit-event-name/edit-event-name.component';


@Component({
  selector: 'app-event-overview',
  templateUrl: './event-overview.component.html',
  styleUrls: ['./event-overview.component.scss']
})
export class EventOverviewComponent implements OnInit, OnChanges {
  @Input() aviationEvent: AviationEvent;
  eventStart: moment;
  eventEnd: moment;
  eventStartString: string;
  eventEndString: string;
  editModeSet = false;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar) { }

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.setDates();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDates();
  }

  setDates() {
    this.eventStart = moment.tz(this.aviationEvent.startDateTime, 'UTC');
    this.eventStartString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
    this.eventEnd = moment.tz(this.aviationEvent.endDateTime, 'UTC');
    this.eventEndString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
  }

  openEditTitleDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {aviationEvent: this.aviationEvent};

    const DIALOG_REF = this._editDescDialog.open(EditEventNameComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.snackBar.open('Event Title', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
